module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; 
var cssClass = [];

if (widget.date.format("isoDate") === date.format("isoDate")) {
	cssClass.push("selected");
}

if (date.format("mm") != widget.month.format("mm")) {
	cssClass.push("outmonth");
}

    ; __append("\n<div class=\"cell gl-pointer ")
    ; __append(escapeFn( cssClass.join(' ') ))
    ; __append("\"  on-click=\"onCellCustomClick\" data-name=\"cellClick\" data-date=\"")
    ; __append(escapeFn( date.format('isoDate') ))
    ; __append("\">\n	<div class=\"content\">\n		<div class=\"day-number\">")
    ; __append(escapeFn( date.format("dd") ))
    ; __append("</div>\n\n		")
    ;  if (events.length > 0) { 
    ; __append("\n			<div class=\"events-count\">\n				")
    ; __append(escapeFn( events.length ))
    ; __append("\n			</div>\n		")
    ;  } 
    ; __append("\n	</div>\n</div>")
  }
  return __output.join("");

}